import { useEffect } from 'react';
import Lenis from 'lenis';

export const useLenis = () => {
  useEffect(() => {
    // 检测是否是移动设备
    const isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
    
    // 初始化 Lenis
    const lenis = new Lenis({
      duration: isMobile ? 1.0 : 1.2,  // 移动端稍快
      easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
      orientation: 'vertical',
      gestureOrientation: 'vertical',
      smoothWheel: true,
      wheelMultiplier: isMobile ? 1 : 1,
      touchMultiplier: isMobile ? 1.5 : 2,  // 移动端触摸优化
      infinite: false,
      syncTouch: true,          // 同步触摸滚动
      syncTouchLerp: 0.1,       // 触摸滚动的插值
      touchInertiaMultiplier: 20, // 触摸惯性
    });

    // 动画循环
    function raf(time) {
      lenis.raf(time);
      requestAnimationFrame(raf);
    }

    requestAnimationFrame(raf);

    // 清理函数
    return () => {
      lenis.destroy();
    };
  }, []);
};

